module.exports = __webpack_public_path__ + "static/media/pr2.f0d2c0cd.jpg";